import styled from "styled-components";

const TitleComponent = styled.h1`
    font-family: ${props => props.fontFamily};
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    color: ${props => props.color};
    text-align: center;
    margin-top: ${props => props.marginTop};
`
export const Title = (props)=>{
    return (
        <TitleComponent 
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            fontWeight={props.fontWeight}
            color={props.color}
            marginTop={props.marginTop}>
            {props.text}
        </TitleComponent>
    )
}
const TextComponent = styled.p`
    font-family: ${props => props.fontFamily};
    font-size: ${props => props.fontSize};
    font-weight: ${props => props.fontWeight};
    color: ${props => props.color};
    text-align: center;
    margin-top: ${props => props.marginTop};
`
export const Text = (props)=>{
    return (
        <TextComponent 
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            fontWeight={props.fontWeight}
            color={props.color}
            marginTop={props.marginTop}>
            {props.text}
        </TextComponent>
    )
}